import { Dialog } from '@ui'
import React, { FC, ReactNode } from 'react'

interface PromptProps {
  show: boolean
  children?: ReactNode
  close?: () => void
}

/** Centred dialog with free-form content. Prefer `Dialog` from @ui with title/description/actions for new code. */
const Prompt: FC<PromptProps> = ({ show, children, close }) => (
  <Dialog open={show} onClose={close} dismissible={!!close}>
    <div className="flex w-full flex-col items-center gap-4">{children}</div>
  </Dialog>
)

export default Prompt
